import { render, staticRenderFns } from "./Chatting.vue?vue&type=template&id=5d69d0b4&"
import script from "./Chatting.vue?vue&type=script&lang=js&"
export * from "./Chatting.vue?vue&type=script&lang=js&"
import style0 from "./Chatting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports